import {EntityFormControl} from "./entity-form-control";

export class EntityFormCollectionControl extends EntityFormControl {

    public static readonly FLAG_CHILD_ERROR = "FLAG_CHILD_ERROR";

}
